// extracted by mini-css-extract-plugin
export default {"section":"Hero_section__KD4-Y","container":"Hero_container__QT2Id","content":"Hero_content__OH-vp","button":"Hero_button__eXa0j"};